import React from 'react';
import withStyles from '@mui/styles/withStyles';
import { Grid, Typography } from '@mui/material';

const styles = theme => ({
  root: {
    maxWidth: 600,
    marginTop: 16
  },
  text: {
    fontWeight: 500,
  },
  logo: {
    display: 'inline',
    height: 20,
    marginBottom: '-6px'
  }
});

class PoweredBy extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <Grid item xs={12} align="center" className={classes.root}>
        <Typography variant="body2" className={classes.text}> 
            Powered&nbsp;by&nbsp;<img alt="AppBind" className={classes.logo} src={'/logos/appbind-logo-c-b.png'} />
        </Typography>
      </Grid>
    )
  }
}

export default withStyles(styles)(PoweredBy);